import styled from 'styled-components';

export const Wrapper = styled.div`
margin: auto !important;
width: 100%;
.video-player {
    border-radius: 24px;
    position: relative;
    overflow: hidden;
    margin: auto !important;
    margin-top: 15px !important;
    ${p => p.center &&`
        @media (max-width: 600px) {
            margin-top: 100px !important;
        }
    `}
    .video {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 1;
    }
}
`